import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ExtractPropertyFloorPlanMutationVariables = Types.Exact<{
  input: Types.ExtractPropertyFloorPlanInput;
}>;


export type ExtractPropertyFloorPlanMutation = { __typename?: 'mutation_root', extract_property_floor_plan?: { __typename?: 'ExtractPropertyFloorPlanOutput', success: boolean, buildings_created?: number | null, floors_created?: number | null, rooms_created?: number | null, error?: string | null } | null };


export const ExtractPropertyFloorPlanDocument = gql`
    mutation extractPropertyFloorPlan($input: ExtractPropertyFloorPlanInput!) {
  extract_property_floor_plan(input: $input) {
    success
    buildings_created
    floors_created
    rooms_created
    error
  }
}
    `;
export type ExtractPropertyFloorPlanMutationFn = Apollo.MutationFunction<ExtractPropertyFloorPlanMutation, ExtractPropertyFloorPlanMutationVariables>;

/**
 * __useExtractPropertyFloorPlanMutation__
 *
 * To run a mutation, you first call `useExtractPropertyFloorPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtractPropertyFloorPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extractPropertyFloorPlanMutation, { data, loading, error }] = useExtractPropertyFloorPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExtractPropertyFloorPlanMutation(baseOptions?: Apollo.MutationHookOptions<ExtractPropertyFloorPlanMutation, ExtractPropertyFloorPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExtractPropertyFloorPlanMutation, ExtractPropertyFloorPlanMutationVariables>(ExtractPropertyFloorPlanDocument, options);
      }
export type ExtractPropertyFloorPlanMutationHookResult = ReturnType<typeof useExtractPropertyFloorPlanMutation>;
export type ExtractPropertyFloorPlanMutationResult = Apollo.MutationResult<ExtractPropertyFloorPlanMutation>;
export type ExtractPropertyFloorPlanMutationOptions = Apollo.BaseMutationOptions<ExtractPropertyFloorPlanMutation, ExtractPropertyFloorPlanMutationVariables>;